/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import './datawrapper.scss';
import Loader from 'react-loader-spinner';
import colors from '../../../../../../../../apps/baykis-pl/pattern-lab/_data/generated_colors.json';
import DownloadList from '../list/downloadList.jsx';

// TODO: remove later
const host = window.location.hostname;
const prefix =
  host.includes('patternlab') ||
  host.includes('styleguide') ||
  host === 'dev.baykis.test' ||
  (host.includes('localhost') && !host.includes('drupal'))
    ? ''
    : '/themes/baykis/dist/app-drupal';

let title = '';

class DatawrapperDownloads extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      fileUrls: [],
    };
  }

  componentDidMount() {
    const {regionName, regionPartitioning} = this.props;
    this.getFileLinks();
    title = this.getRegionLabel(regionName, regionPartitioning);
  }

  componentDidUpdate(prevProps) {
    const {epoch, fileFormat, activeRegion, regionName, regionPartitioning} = this.props;
    if (
      prevProps.epoch === epoch &&
      prevProps.fileFormat === fileFormat &&
      prevProps.activeRegion === activeRegion
    ) {
      return;
    }

    this.getFileLinks();
    title = this.getRegionLabel(regionName, regionPartitioning);
  }

  getFileLinks() {
    this.setState({isLoading: true});
    const {apiUrl, activeRegion, fileFormat, epoch} = this.props;
    const url = `${apiUrl}fetch/${activeRegion}/${epoch}/${fileFormat}`;
    fetch(url, {
      method: 'get',
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.setState({fileUrls: data, isLoading: false});
      });
  }

  render() {
    const {isLoading, fileUrls} = this.state;

    if (!isLoading) {
      const {apiUrl, activeRegion, fileFormat, epoch} = this.props;
      const downloadUrl = `${apiUrl}download`;

      return (
        <div className="datawrapper grid__bit -w9-tablet">
          <DownloadList
            fileUrls={fileUrls}
            downloadEndpoint={downloadUrl}
            epoch={epoch}
            chartTitle={title}
          />
        </div>
      );
    }
    return (
      <div className="datawrapper grid__bit -w9-tablet">
        <Loader
          type="Bars"
          color={colors.themeBase.accent}
          height={100}
          width={100}
          className="isLoading"
        />
      </div>
    );
  }

  getRegionLabel(regionName, regionPartitioning) {
    if (['Alpen', 'Alpenvorland'].includes(regionName)) {
      return `${regionName} (${regionPartitioning})`;
    }

    return regionName;
  }
}

DatawrapperDownloads.propTypes = {
  activeRegion: PropTypes.number,
};

DatawrapperDownloads.defaultProps = {
  activeRegion: 11,
};

export default DatawrapperDownloads;
